import { render, staticRenderFns } from "./EcommerceSummaryCards.vue?vue&type=template&id=336f53b2"
import script from "./EcommerceSummaryCards.vue?vue&type=script&lang=js"
export * from "./EcommerceSummaryCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports